import React, { useEffect, useRef } from "react";
import { FaArrowUp } from "react-icons/fa";
import { Images } from "../../config";
import Loader from "../loader";
import prompts from "../../config/utility-arrays/aiprompts";
import popover from "../popover";

const VisionAIChatInput = ({
  disabled = false,
  placeholder = "What are you looking for?",
  value,
  onChange,
  onClick,
  onKeyDown,
  loading = false,
  disablePrompt = true,
  ...rest
}) => {
  const textRef = useRef(null);

  const handleSend = () => {
    const trimmed = (value ?? "").trim();
    if (!trimmed || disabled || loading) return;
    onClick(trimmed);
  };

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;

    const fontSizePx = parseFloat(window.getComputedStyle(el).fontSize) || 16;

    el.style.height = "auto";
    const heightPx = el.scrollHeight;
    const heightEm = heightPx / fontSizePx;

    el.style.height = `${heightEm}em`;
  }, [value]);

  return (
    <div
      className="relative flex flex-col gap-4 w-full p-5 bg-white ring-1 ring-[#F5E4F5] rounded-2xl"
      {...rest}
    >
      <textarea
        ref={textRef}
        value={value}
        onChange={onChange}
        rows={1}
        className="outline-none flex-grow resize-none overflow-y-auto leading-[1.5] max-h-48 text-[1.2em]"
        disabled={disabled}
        placeholder={placeholder}
        aria-label="Message input"
        onKeyDown={onKeyDown}
      />
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <popover.WhitePopover
            content={
              <div
                className={`flex gap-5 flex-wrap justify-center items-center w-[46em]`}
              >
                {prompts.map((item, index) => (
                  <div
                    key={index}
                    className="p-2 flex gap-2 items-center justify-center rounded-full border border-gray-400 cursor-pointer bg-white/30 hover:drop-shadow-lg"
                    onClick={() => {
                      onClick(item.message);
                    }}
                  >
                    <div
                      className={`h-[3em] w-[3em] flex justify-center items-center rounded-full ${item.gradient}`}
                    >
                      <img src={item.icon} className="h-[1.5em] w-[1.5em]" />
                    </div>
                    <div className="text-[1.5em] pr-2">{item.text}</div>
                  </div>
                ))}
              </div>
            }
            placement={"top"}
            trigger="click"
          >
            <div
              className={`flex items-center justify-center gap-1 w-max px-3 py-2 bg-white ring-1 ring-[#F5E4F5] rounded-full  ${
                disablePrompt
                  ? "cursor-default pointer-events-none"
                  : "cursor-pointer"
              }`}
            >
              <img
                src={Images.VisionAIBrowsePrompt}
                className="h-[1em] w-auto"
              />
              <p className="text-[1.2em] pr-2">Browse Prompts</p>
            </div>
          </popover.WhitePopover>
        </div>

        <button
          type="button"
          className={`rounded-full h-[3em] w-[3em] bg-gradient-to-t from-[#387F75] to-[#58C2B3] flex justify-center items-center ${
            disabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"
          }`}
          onClick={handleSend}
          disabled={disabled || loading}
          aria-label="Send message"
        >
          {loading ? (
            <Loader.ButtonLoader />
          ) : (
            <FaArrowUp className="text-white text-[1.4em]" />
          )}
        </button>
      </div>
    </div>
  );
};

export default VisionAIChatInput;
